import { FC } from "react";
import FlexCenter from "shared/components/Layout/components/FlexCenter";
import {
  ModuleTitleSkeleton,
  ModuleTypeSkeleton,
  ModuleScheduleSkeleton,
  SkeletonContainer,
  ModuleActionSkeleton,
} from "./styled";

const ModuleHeaderSkeleton: FC = () => {
  return (
    <SkeletonContainer>
      <FlexCenter>
        <ModuleTitleSkeleton />
        <ModuleTypeSkeleton />
      </FlexCenter>
      <FlexCenter>
        <ModuleScheduleSkeleton />
        <ModuleTypeSkeleton />
        <ModuleActionSkeleton />
      </FlexCenter>
    </SkeletonContainer>
  );
};

export default ModuleHeaderSkeleton;
